/*
 * @Description: 表格处理相关函数
 * @Author: xiaolibin
 * @Date: 2022-09-19 10:43:32
 * @FilePath: /km-supply-chain/src/pages/distributor/trade/order/audit/table/service/service.table.help.js
 */
import { cloneDeep } from 'lodash';
import { isFxTrade } from '@pages/distributor/trade/utils/index.js';
import no_pic from '@assets/images/no_pic.png';
//  处理表格数据，订单商品数据不会一次性全部展示出来
export function dwTableList(list, checkedSids = []) {
  const tableList = cloneDeep(list);
  return tableList.map((item, index) => {
    let totalCost = 0;
    item.orders.forEach(i => {
      i.totalCost = (i.num * i.cost).toFixed(2);
      totalCost += Number(i.totalCost ?? 0);
    });
    item.orders = item.orders ?? [];
    // item.hasRowSeat = item.orders.length > 2;
    item.check = checkedSids.includes(item.sid);
    return { ...item, totalCost };
  });
}

// 图片错的时候展示默认图片
export function hintPic(e) {
  e.target.src = no_pic;
}

// 判断是否是发货后
export function isAfterSendGoods(rowData) {
  return ['FINISHED', 'SELLER_SEND_GOODS', 'CLOSED'].includes(rowData.sysStatus);
}

// 已发货和已作废的订单不能修改 ，待审核
export function isWaitAudit(rowData) {
  return ['WAIT_AUDIT'].includes(rowData.sysStatus);
}

// 判断是否已审核
export function isAlreadyWait(rowData) {
  return ['WAIT_EXPRESS_PRINT', 'WAIT_SEND_GOODS'].includes(rowData.sysStatus);
}

// 待推送状态
export function isWaitPush(rowData) {
  return rowData.sysStatus === 'WAIT_AUDIT' && isFxTrade(rowData);
}

// 判断是否为现场自提
export function isSelfPickUp(rowData) {
  return (rowData.tagList || []).some(item => item.tagName === '现场自提');
}